import React, { useEffect, useState } from "react";
import "./About.css";

function About() {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth > 515) {
        setHeight(window.innerHeight);
      } else {
        setHeight("max-content");
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <div className="container p-3 mb-5 bg-body rounded">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="card-body title-hr">
                <div className="sub-section-title-1">
                  <h2>About Me</h2>
                </div>
              </div>
              <p className="about-me">
                <span>Hello! My name is Ishan Tharindu</span> and I am a
                freelance developer and an undergraduate student currently
                studying Computer Science & Technology degree program. I
                specialize in front-end development using ReactJS, Bootstrap,
                and Tailwind CSS. I am also proficient in Java, JavaScript, and
                Python, and have experience working on both individual and group
                projects.
                <br />
                <br />I am always eager to learn new technologies and am
                passionate about sharing my knowledge with others. In my free
                time, I enjoy hanging out with friends and exploring new
                hobbies.
              </p>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="card-body title-hr">
                <div className="sub-section-title-2">
                  <h2>Basic Information</h2>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <strong>Full Name:</strong>
                </div>
                <div className="col-sm-8">
                  <span>Garusingha Ishan Tharindu Gunawardhana</span>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <strong>Age:</strong>
                </div>
                <div className="col-sm-8">
                  <span>{new Date().getFullYear() - 1998}</span>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <strong>Email:</strong>
                </div>
                <div className="col-sm-8">
                  <span>t.gunawardana864@gmail.com</span>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <strong>Phone:</strong>
                </div>
                <div className="col-sm-8">
                  <span>+94 71 5751 121</span>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <strong>Address:</strong>
                </div>
                <div className="col-sm-8">
                  <span>
                    12/P, Pahadahena, Wewaihalagoda, Kekanadura, Matara, Sri
                    Lanaka
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <strong>Language:</strong>
                </div>
                <div className="col-sm-8">
                  <span>English, Sinhala</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
